var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpSupport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.6625 9.21426L13.9625 14.5143M21.0375 14.5143L26.3375 9.21426M21.0375 21.5893L26.3375 26.8893M13.9625 21.5893L8.6625 26.8893M30 18.0518C30 24.9553 24.4036 30.5518 17.5 30.5518C10.5964 30.5518 5 24.9553 5 18.0518C5 11.1482 10.5964 5.55176 17.5 5.55176C24.4036 5.55176 30 11.1482 30 18.0518ZM22.5 18.0518C22.5 20.8132 20.2614 23.0518 17.5 23.0518C14.7386 23.0518 12.5 20.8132 12.5 18.0518C12.5 15.2903 14.7386 13.0518 17.5 13.0518C20.2614 13.0518 22.5 15.2903 22.5 18.0518Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpSupport);
export default __webpack_public_path__ + "static/media/helpSupport.a184b86fc87bb4bb7556ba779c9eff66.svg";
export { ForwardRef as ReactComponent };